import { styled } from '@mui/material/styles';
import Typography from '../../../../../library/Typography';

export const StyledTypography = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));
